import { render, staticRenderFns } from "./eventConfiguration.vue?vue&type=template&id=3ff580bd"
import script from "./eventConfiguration.vue?vue&type=script&lang=js"
export * from "./eventConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports